import React from 'react';
import { CabecalhoStyled, EmpresaNomeStyled, InicialStyled, LogoQuadradoStyled, MarcaStyled, MarcaTextosStyled, SubtituloStyled, TituloStyled, UnidadeNomeStyled, } from './nps-cabecalho.component.style';
export var NpsCabecalho = function (_a) {
    var logo = _a.logo, empresa = _a.empresa, unidade = _a.unidade, titulo = _a.titulo, subtitulo = _a.subtitulo;
    return (React.createElement(CabecalhoStyled, null,
        React.createElement(MarcaStyled, null,
            React.createElement(LogoQuadradoStyled, null, logo ? (React.createElement("img", { src: logo, alt: ("Logo " + (empresa !== null && empresa !== void 0 ? empresa : '')).trim() })) : (React.createElement(InicialStyled, { "aria-hidden": "true" }, (empresa !== null && empresa !== void 0 ? empresa : '').charAt(0).toUpperCase()))),
            React.createElement(MarcaTextosStyled, null,
                React.createElement(EmpresaNomeStyled, null, empresa),
                unidade && React.createElement(UnidadeNomeStyled, null, unidade))),
        React.createElement(TituloStyled, null, titulo),
        React.createElement(SubtituloStyled, null, subtitulo)));
};
